import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAttrs, toRef } from 'vue'
import _ from 'lodash'

interface IProps {
  rootClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  background?: string
  borderless?: boolean
  isHover?: boolean
  isSelected?: boolean
}

interface IEmits {
  (event: 'click', data: PointerEvent): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KCircleIcon', inheritAttrs: false },
  __name: 'KCircleIcon',
  props: {
    rootClass: { default: 'q-pa-xs' },
    background: { default: '' },
    borderless: { type: Boolean, default: false },
    isHover: { type: Boolean, default: false },
    isSelected: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any) {







const attrs = useAttrs()
const sanitisedAttrs = toRef(() => _.omit(attrs, 'onClick'))

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["k-circle-icon transition rounded-circle flex inline", [
      __props.rootClass,
      `bg-${__props.background}`,
      {
        'k-icon-circle--border': !__props.borderless,
        'k-icon-circle--hover': __props.isHover,
        'k-icon-circle--active': __props.isSelected,
      },
    ]]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click', $event)), ["stop"]))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_k_icon, _mergeProps(sanitisedAttrs.value, { hoverable: __props.isHover }), null, 16 /* FULL_PROPS */, ["hoverable"]),
      _renderSlot(_ctx.$slots, "action")
    ])
  ], 2 /* CLASS */))
}
}

})